<template>
	<div id="orders-list" class="orders-list">

		<div class="controls-wrapper" v-if="combineOrder">
			<base-button :fromMainPOS="true" customStyles="margin-right: 12px;" text="Combine orders" :isDisabled="!hasCheckedOptions || loading" class="fn_btn" classes="def-btn main-action-btn uppercase medium border-2" @onClick="combineOrders"/>
			<base-button :fromMainPOS="true" :imgSrc="'closeRed'" :customStyles="'min-width: 60px; width: 60px; height: 60px; border: none'" classes="def-btn secondary-action-btn icon one square-btn" @onClick="resetCombine"/>
		</div>
		<div class="controls-wrapper" v-else>
			<base-button :fromMainPOS="true" text="NEW ORDER" customStyles="margin-right: 12px;" imgSrc="addWhite" class="fn_btn" classes="def-btn main-action-btn icon left uppercase medium border-2" @onClick="openNewOrderModal"/>
			<refresh-btn-component ref="refresh-btn" :fromMainPOS="true" @click="this.getOrders({resetList: true, resetSelected: true})" class="refresh-btn" :customStyles="'border: none;'"></refresh-btn-component>
		</div>
		<Teleport to="body"><div v-if="diningOpen" class="ordering-overlay" @keydown.esc="diningOpen=false"><section class="ordering-dialog" v-ordering-dialog role="dialog" aria-modal="true" aria-label="New order">
<header><strong>New order</strong><button aria-label="Close new order" @click="diningOpen=false">×</button></header>
<div class="dialog-body"><input v-model="tableSearch" placeholder="Enter table number" aria-label="Enter table number" autofocus>
<label v-if="serviceStations.length" class="station-picker">Service station <select v-model="stationId"><option :value="null">All stations</option><option v-for="station in serviceStations" :key="station.id" :value="Number(station.id)">{{station.name}}</option></select></label>
<p v-if="diningLoading" role="status">Loading tables…</p><p v-if="diningError" role="alert">{{diningError}}</p>
<div class="table-options"><button v-for="table in visibleDiningTables.filter(t=>String(t.table_name).toLowerCase().includes(tableSearch.toLowerCase()))" :key="table.table_id" :class="{chosen:selectedTable?.table_id===table.table_id}" @click="selectedTable=table;selectedVisit=null" :disabled="diningLoading">
  <span class="table-description"><span class="table-heading"><span>Table #{{table.table_name}}</span><span class="table-status" :data-status="tableStatus(table)" :style="tableStatusStyle(table)">{{tableStatusLabel(table)}}</span></span>
    <small v-if="table.open_orders.length">Continue open order</small>
    <small v-if="table.seatings.length">{{tableGuestCount(table)}} guest(s)</small>
    <small v-for="p in table.placements?.filter(p=>p.status_note) || []" :key="p.id">{{p.status_note}}</small>
  </span><span class="table-capacity">{{table.capacity}} seats</span>
</button></div>
<div v-if="selectedTable && (selectedTable.open_orders.length>1 || selectedTable.seatings.length>1)" class="visit-options"><strong>Select existing check or seating</strong><button v-for="id in selectedTable.open_orders" :key="id" :class="{chosen:selectedVisit?.order===id}" @click="selectedVisit={order:id}">Open check {{String(id).slice(-8)}}</button><button v-for="seating in selectedTable.seatings" :key="seating.reservation_table_id" :class="{chosen:selectedVisit?.seating===seating}" @click="selectedVisit={seating}">Seating {{seating.reservation_table_id}} · {{seating.guest_name || 'Dining guests'}}</button></div>
<p v-if="!diningLoading && !visibleDiningTables.filter(t=>String(t.table_name).toLowerCase().includes(tableSearch.toLowerCase())).length">No matching tables in this station.</p></div>
<footer><button @click="diningOpen=false">Cancel</button><button class="primary" :disabled="!selectedTable || diningLoading" @click="confirmDiningTable">{{selectedTable?.open_orders.length ? 'Continue order' : 'Confirm'}}</button></footer>
</section></div></Teleport>
<search-bar-component @onInput="(e) => this.debounceSearch(e)" parentComp="menuList" :placeholder="'Code, Table, Waiter, etc.'" @onClear="onInputClear"></search-bar-component>
		<div class="loading" v-if="loading">
			<icon-component iconName="loader" />
		</div>
		<div v-else class="list" @scroll="(e) => this.ordersListScrollHandle(e)">
			<div
				v-for="(i, index) in orders" :key="index"
				@click="onOrderSelect(i)"
				class="order"
				:class="{'active-order': i.active, 'highlighted': isHighlighted(i)}"
			>
				<div class="table">
					<div class="table-wrapper">
						<icon-component
              :iconName="isRetailMode ? 'retailIcon' : configureOrderStatus(i)"
            />
						<div class="table-number">{{ i.table ? i.table : null }}</div>
					</div>
					<div class="checkbox-wrap" v-if="combineOrder" @click.stop.prevent="i.idCheck ? null : i.checked = !i.checked">
						<icon-component v-if="i.idCheck" iconName="checkboxCheckedBg" />
						<icon-component v-else-if="i.checked" iconName="checkboxChecked" />
						<icon-component v-else iconName="checkboxUnchecked" />
					</div>
					<icon-component v-else iconName="dots" class="order-options" :style="{visibility : authUser?.user.role === 'waiter assist' ? 'hidden' : 'visible'}" @click="openOrderOptionsModal(i)" />
				</div>
				<div class="text waiter">WAITER: <span>{{ i.serviced_by ? i.serviced_by.name : i.opened_by.name }}</span></div>
				<div class="text guest">GUEST:
					<span>{{ i.dining_party_leaders?.length ? i.dining_party_leaders.map(p=>p.name).join(', ') : (i.payers.length ? `${i.payers[0].first_name || ''} ${i.payers[0].last_name || ''}` : 'Not specified') }}</span>
				</div>
				<div class="text cabin">CABIN:
					<span>{{
							i.dining_party_leaders?.length ? i.dining_party_leaders.map(p=>p.cabin || 'Not specified').join(', ') : (i.payers.length ? (i.payers[0].cabin || 'Not specified') : 'Not specified')
						}}</span>
				</div>
				<div v-if="i.public_code" class="text cabin">CODE:
					<span>{{ i.public_code }}</span>
				</div>
			</div>
		</div>
	</div>
	<teleport to="body">
		<new-order-modal-component
			v-if="showNewOrderModal"
			ref="new-order-modal"
			:set-payer-after="authData.posData?.department.flow_ordering_guest"
			@addTempOrder="createTempOrder"
		/>

		<order-options-modal
			v-if="showOrderOptionsModal"
			ref="order-options-modal"
			:selectedOrder="selectedOrder"
			@combineOrder="combineOrder = true"
			@splitOrder="splittingOrder"
			@onModalClose="onCombineOrdersModalClose"
			@closeOrderOptionsModal="closeOrderOptionsModal"
		/>

		<users-modal
			:selectedOrder="selectedOrder"
			v-if="usersModalRef"
			ref="usersModalRef"
			:new-order-creation="true"
			@onSetPayer="setPayer"
			@addPayer="setPayer"
			@onModalClose="usersModalRef = false"
		/>

		<split-order-modal
			v-if="splitOrderModalRef"
			:selectedOrder="selectedOrder"
			ref="splitOrderModalRef"
			@splitOrder="splitOrders"
			@onModalClose="splitOrderModalRef = false"
		/>

		<confirmation-modal-component
			ref="confirmation-modal-component"
			:has-cancel-btn="false"
		/>

		<barcode-scan-interceptor
			@submitBarcode="handleBarcode"
			:openedFromLogin="false"
		/>
	</teleport>
</template>

<script>
import {orderingDialog} from '@/_helpers/ordering-dialog';
import axios from 'axios';
import SearchBarComponent from "@/components/_shared/SearchBar";
import RefreshBtnComponent from "@/components/_shared/RefreshButton";
import ModalComponent from "@/components/_shared/Modal";
import Keypad from "@/components/_shared/Keypad";
import NewOrderModalComponent from "@/components/_modals/NewOrderModal";
import OrderOptionsModal from "@/components/_modals/OrderOptionsModal";
import UsersModal from "@/components/_modals/UsersModal";
import {authService} from "@/_api/auth.api";
import store from "@/store";
import SplitOrderModal from "@/components/_modals/SplitOrderModal";
import {settingsService} from "@/_api/settings.api";
import ConfirmationModalComponent from "@/components/_shared/ConfirmationModal.vue";
import {orderService} from "@/_api/order.api";
import {formatDataService as formatItemCondiments, formatDataService} from "@/_helpers/format-data";
import {constants} from "@/constants/constants";
import BaseButton from "@/components/_shared/Button.vue";
import BarcodeScanInterceptor from "@/components/_shared/BarcodeScanInterceptor.vue";
import getPosHelper from "@/_helpers/get-pos-helper";
import iconComponent from "@/components/_shared/Icon.vue";

export default {
  directives:{orderingDialog},
	name: 'OrdersListComponent',
	props: {
        orderingMode: Boolean,
		/*orders: {
			type: Array
		},*/
		selectedOrder: {
			type: Object
		},
		modalOpened: {
			type: [Boolean, Number],
			required: false
		}
	},
	emits: ['refresh', 'updateOrder'],
	components: {
		BarcodeScanInterceptor,
		ConfirmationModalComponent,
		OrderOptionsModal,
		NewOrderModalComponent,
		Keypad,
		ModalComponent,
		RefreshBtnComponent,
		SearchBarComponent,
		UsersModal,
		SplitOrderModal,
		BaseButton,
		iconComponent
	},
	data() {
		return {
			orders: [],
            selectedTable:null,selectedVisit:null, tableSearch:'', stationId:null, serviceStations:[], stationLoaded:false, diningOpen: false, diningLoading: false, diningSeatings: [], diningTables: [], diningError: '',
			total: 0,
			page: 0,
			per_page: 9,
			searchOrder: null,
			loading: false,
			orderLoading: false,

			showNewOrderModal: false,
			showOrderOptionsModal: false,
			usersModalRef: false,
			combineOrder: false,
			highlighted: null,
			combineOrdersIn: null,
			splitOrderModalRef: false,
			// ADDITION_LEGAL_AGE_TABACCO: 0,
			// ADDITION_LEGAL_AGE_ALCOHOL: 0,

			focusSearchMenu: false,
		}
	},

	watch: { stationId(){this.selectedTable=null;} },
	computed: {
        visibleDiningTables(){return this.stationId===null ? this.diningTables : this.diningTables.filter(t=>Number(t.service_station_id)===Number(this.stationId));},
		hasCheckedOptions: function () {
			return this.orders.filter((o) => {return o.checked}).length
		},
		authData() {
			return this.$store.state.auth
		},
		authUser() {
			return this.$store.state.auth.user
		},
		legalAge() {
			return this.$store.state.settings.legalAge;
		},
		orderPayerModes() {
			const mods = this.$store.state.auth.posData?.department.order_payer_addition_modes;
			if (mods.length === 2) {
				return 'both'
			}
			if (mods.length < 2 && mods[0].id === 2) {
				return 'card'
			} else {
				return 'manual'
			}
			// return this.$store.state.auth.posData.department.order_payer_addition_modes
		},
		getBusinessDay() {
			return this.$store.state.settings.businessDay
		},
    isRetailMode() {
      return this.$store.state.auth?.posData?.department?.retail_mode
    },
	},
	mounted() {
		this.diningRefreshTimer=setInterval(()=>this.refreshDiningTables(),5000);
		this.getOrders({resetList: true, resetSelected: true});
		this.emmiter.on('updateOrderInList', (h) => {
			let index;
			if (h.data.id === constants.tempOrderID) {
				index = this.orders.findIndex((i) => i.tempId === h.data.tempId);
			} else {
				if (h.removedItem) { // method to find and replace temp order with created one
					index = this.orders.findIndex((i) => i.tempId === h.removedItem[0].tempId);
				} else {
					index = this.orders.findIndex((i) => i.id === h.data.id);
				}
			}
			if (index !== -1) {
				if (h.action === 'remove') {
					this.orders.splice(index, 1);
				} else if (h.action === 'replace') {
					this.orders[index] = {...h.data, active: true};
				} else {
					this.orders[index] = {...this.orders[index], ...h.data};
				}

			}
		});

    this.emmiter.on('refreshOrders', () => {
      this.getOrders({resetList: true, resetSelected: false})
    });

		this.emmiter.on('updatePackagePlanOrderInList', (payload) => {
      if (typeof payload?.oldOrder?.tempId !== 'undefined') {
        const oldOrderIdx = this.orders?.findIndex((orderItem) => orderItem.tempId === payload.oldOrder.tempId);
        if (oldOrderIdx >= 0) {
          this.orders?.splice(oldOrderIdx, 1);
        }
      }

      const newOrderIdx = this.orders?.findIndex((orderItem) => orderItem.id === payload.newOrder.id);
      if (newOrderIdx >= 0) {
        this.orders[newOrderIdx] = JSON.parse(JSON.stringify({
          ...payload.newOrder,
          active: true,
        }));

        this.$emit('updateOrder', payload.newOrder);

        return;
      }

      this.orders.push({
        ...payload.newOrder,
        active: true,
      });

      this.$emit('updateOrder', payload.newOrder);
    });

		this.emmiter.on('singleOrderLoading', (data) => {
			this.orderLoading = data;
		});
		this.emmiter.on('focusSearchMenu', (data) => {
			this.focusSearchMenu = data;
			// console.log('this.focusSearchMenu', this.focusSearchMenu);
		});
		this.emmiter.on('clickButtonFromMainPOS', (data) => {
			// console.log('clickButtonFromMainPOS', data);
			// console.log('activeOrder', document.getElementsByClassName('active-order')[0]);
			if (document.getElementsByClassName('active-order')[0]) {
				// const evt = new KeyboardEvent('keydown', {
				// 	key: 'Enter',
				// 	code: 'Enter',
				// 	which: 13,
				// 	keyCode: 13,
				// });
				const evt = document.createEvent("MouseEvents");
				evt.initMouseEvent("click", true, true, window,
				0, 0, 0, 0, 0, false, false, false, false, 0, null);
				document.getElementsByClassName('active-order')[0].dispatchEvent(evt);
				// document.getElementsByClassName('active-order')[0].click()
				// document.getElementsByClassName('active-order')[0].setAttribute('tabindex', '-1');
			}
		});
	},
	beforeUnmount() {
		clearInterval(this.diningRefreshTimer);
		this.emmiter.off('updateOrderInList')
		this.emmiter.off('singleOrderLoading')
		this.emmiter.off('focusSearchMenu')
		this.emmiter.off('clickButtonFromMainPOS')
		this.emmiter.off('updatePackagePlanOrderInList')
		this.emmiter.off('refreshOrders')
	},
	methods: {
        async refreshDiningTables(){
            if(!this.diningOpen || this.diningLoading || this.diningRefreshing)return;
            this.diningRefreshing=true;
            try{
                const {data}=await axios.get('/dining/tables');
                if(!this.diningOpen || this.diningLoading)return;
                this.diningError='';
                this.diningTables=data.tables.sort((a,b)=>String(a.table_name).localeCompare(String(b.table_name),undefined,{numeric:true}));
                if(this.selectedTable)this.selectedTable=this.diningTables.find(t=>t.table_id===this.selectedTable.table_id) || null;
                if(this.selectedVisit?.seating){const id=this.selectedVisit.seating.reservation_table_id;const seating=this.selectedTable?.seatings.find(s=>s.reservation_table_id===id);this.selectedVisit=seating?{seating}:null;}
                if(this.selectedVisit?.order && !this.selectedTable?.open_orders.includes(this.selectedVisit.order))this.selectedVisit=null;
            }catch(e){if(this.diningOpen)this.diningError='Table status refresh failed. Reload before opening a new order.';}
            finally{this.diningRefreshing=false;}
        },
        tableGuestCount(table){return table.seatings.reduce((total,s)=>total+(s.seats?.length || s.people_count || 0),0);},
        tableStatusLabel(table){
            const status=this.tableStatus(table);
            const dirty=(table.placements || []).some(p=>p.cleaning_status==='dirty');
            return status.replace(/_/g,' ') + (table.payment_status==='paid' ? ' \u00b7 Paid' : '') + (dirty && status!=='dirty' ? ' \u00b7 Dirty' : '');
        },
        tableStatusStyle(table){
            const status=this.tableStatus(table);const p=(table.placements || []).find(p=>p.display_status===status);
            const colors={green:'#d1fadf',yellow:'#fef0c7',orange:'#fedf89',red:'#fee4e2',brown:'#dcc6b6',gray:'#eaecf0',blue:'#d1e9ff',white:'#ffffff'};
            return {background:colors[p?.color] || '#f2f4f7',border:`2px solid ${p?.stroke_color==='brown'?'#6b3f23':(colors[p?.color] || '#d0d5dd')}`,borderRadius:'5px',padding:'4px 8px',color:'#344054',textTransform:'capitalize'};
        },
        tableStatus(table){
            const placements=table.placements || [];
            const priority=['blocked','on_hold','dirty','occupied','reserved','available'];
            const p=[...placements].sort((a,b)=>priority.indexOf(a.display_status)-priority.indexOf(b.display_status))[0];
            return p?.display_status || (table.seatings.length?'occupied':'available');
        },
        async tableCommand(table,action){
            if(this.diningLoading)return;this.diningLoading=true;this.diningError='';
            const key=`table-command:${table.table_id}:${action}:${table.lifecycle.revision}`;
            const command=sessionStorage.getItem(key) || crypto.randomUUID();sessionStorage.setItem(key,command);
            try{await axios.post(`/dining/tables/${table.table_id}/commands`,{command_id:command,action,revision:table.lifecycle.revision});sessionStorage.removeItem(key);this.diningLoading=false;await this.loadDiningSeatings();}
            catch(e){if(e.response && e.response.status<500)sessionStorage.removeItem(key);this.diningError=e.response?.data?.message || 'Dining result unknown. Retry the same action.';}
            finally{this.diningLoading=false;}
        },
        async confirmDiningTable(){const t=this.selectedTable;if(!t || this.diningLoading)return;if(t.open_orders.length>1 || t.seatings.length>1){if(!this.selectedVisit){this.diningError='Select the check or seating to continue.';return;}if(this.selectedVisit.order)this.openExistingTableOrder(this.selectedVisit.order);else await this.openDiningSeating(this.selectedVisit.seating);return;}if(t.open_orders.length)this.openExistingTableOrder(t.open_orders[0]);else if(t.seatings.length)await this.openDiningSeating(t.seatings[0]);else await this.openDiningTable(t);},
        async loadDiningSeatings() {
            if (this.diningLoading) return;
            this.selectedTable=null; this.tableSearch=''; this.diningOpen = true; this.diningLoading = true; this.diningError = '';
            try { const mode=(await axios.get('/kitchen/mode')).data; this.serviceStations=mode.stations || []; if(!this.stationLoaded){this.stationId=mode.station_id;this.stationLoaded=true;} this.diningTables = (await axios.get('/dining/tables')).data.tables.sort((a,b)=>String(a.table_name).localeCompare(String(b.table_name), undefined, {numeric:true})); }
            catch(e) { this.diningError = e.response?.data?.message || 'Dining is unavailable. Please retry.'; }
            finally { this.diningLoading = false; }
        },
        openExistingTableOrder(id){this.diningOpen=false;this.getOrders({resetList:true,resetSelected:true},id);},
        async openDiningTable(table){
            if(this.diningLoading)return;
            this.diningLoading=true;this.diningError='';
            try{const {data}=await axios.post(`/dining/tables/${table.table_id}/order`);this.openExistingTableOrder(data.order_id);}
            catch(e){this.diningError=e.response?.data?.message || 'Could not open this table.';}
            finally{this.diningLoading=false;}
        },
        async openDiningSeating(seating) {
            if (this.diningLoading) return;
            this.diningLoading = true; this.diningError = '';
            try {
                const result = (await axios.post(`/dining/seatings/${seating.reservation_table_id}/order`)).data;
                if(result.status !== 1) { this.diningError = result.status === 2 ? 'This visit is paid. Complete service and cleaning before seating new guests.' : 'This seating has a cancelled check. Review it in Checks.'; return; }
                this.diningOpen = false;
                this.getOrders({resetList:true,resetSelected:true}, result.order_id);
            } catch(e) { this.diningError = e.response?.data?.message || 'Could not open the order. Retry safely.'; }
            finally { this.diningLoading = false; }
        },
		sortOrders() {
			// this.orders[0].items[0].status = 2;
			// this.orders[1].items[0].status = 2;
			// this.orders[2].items[0].status = 3;
			// this.orders[2].items[1].status = 3;
			// this.orders[2].items[2].status = 3;

			this.orders.forEach((o) => {
				if (this.configureOrderStatus(o) === 'redTable') {
					o['tsc'] = 1;
				} else if (this.configureOrderStatus(o) === 'yellowTable') {
					o['tsc'] = 2;
				} else if (this.configureOrderStatus(o) === 'greenTable') {
					o['tsc'] = 3;
				}
			})
			this.orders = this.orders.sort((a, b) => a.table - b.table).sort((a, b) => a.tsc - b.tsc);
		},
		getOrders(reset, findAndSelect) {
			if (!this.loading) {
				if (reset.resetList) {
					this.page = 0;
					this.orders = [];
					this.loading = true;
				}
				if (reset.resetSelected) {
					this.$emit('updateOrder', null);
				}
				return orderService.getOrders({
          posSearch: this.searchOrder ? this.searchOrder : null,
					status: 1,
					page: !this.page ? this.page += 1 : this.page,
					per_page: this.per_page,
				}).then(async res => {
					// A newly opened/combined check may be outside the first page.
					if(findAndSelect && !res.data.some(o=>o.id===findAndSelect)){
						res.data.unshift(await orderService.getSingleOrder(findAndSelect));
					}
					res.data.forEach(el => {
						this.orders.push(el);
					});
					if (res.data.length > 0) {
						this.page += 1;
					}

					if (reset.resetList) {
						let tempOrders = JSON.parse(localStorage.getItem('tempOrders'));
						if (tempOrders) {
							if (this.searchOrder !== null) {
								tempOrders.forEach((i) => {
									if ((i.table && i.table.toString().includes(this.searchOrder)) || (i.payers[0] && i.payers[0].cabin.includes(this.searchOrder))) {
										this.orders.unshift(i);
									}
								})
							} else {
								this.orders = tempOrders.concat(this.orders);
							}
							this.orders.forEach((o) => {
								o['active'] = false
							})
						}
					}

					if (this.selectedOrder) {
						this.orders.forEach((o) => {
							o['active'] = false;
							if (o.id !== null) {
								if (o.id === this.selectedOrder.id) {
									o['active'] = true;
									this.$emit('updateOrder', o);
								}
							} else {
								if (o.tempId === this.selectedOrder.tempId) {
									o['active'] = true;
									this.$emit('updateOrder', o);
								}
							}
						})
					}

					if (findAndSelect) {
						this.orders.forEach((o) => {
							o['active'] = false;
							if (o.id === findAndSelect) {
								o['active'] = true;
								// this.selectedOrder = o;
								this.$emit('updateOrder', o);
								//this.handleItemCondiments(this.selectedOrder);
								//this.handleItemModifiers(this.selectedOrder);
							}
						})
					}
					this.sortOrders();
					this.loading = false;
				}).catch((err) => {
					this.loading = false;
					console.error(err)
				})
			}
		},
		updateOrdersList(data) {
			this.orders.forEach((o) => {
				o['active'] = false;
			});
			this.orders.unshift(data);
			this.$emit('updateOrder', this.orders[0]);
			// this.selectedOrder = this.orders[0];
		},
		updateOrder(data) {
			this.orders.forEach((yy, index) => {
				if ((this.selectedOrder.id !== null && (yy.id === this.selectedOrder.id)) || (this.selectedOrder.id === null && (yy.tempId === this.selectedOrder.tempId))) {
					this.orders[index] = data;
				}
			});
		},
		handleBarcode(data) {
			// console.log('handleBarcode--OL', data);
			if (this.focusSearchMenu || data.code.toString().length < 16) {
				return
			};
			if (this.orderPayerModes !== "manual") {
				if (this.modalOpened) {
					this.emmiter.emit('barcodeScannedHID', {barcode: data});
				} else {
					orderService.getUsers({
						search: data.code,
						order_by: 'cabin',
						sort: 'asc',
						page: 1,
						per_page: 10000000,
            barcode_scan_type: data.scanned_type,
					}).then((res) => {
						if (res.data.length) {
							const user = res.data[0];
							user['addition_mode'] = constants.payerAddedModes[1];
							user['barcode_scan_type'] = data.scanned_type;

							if (user.posting_allowed) {
								let tableRequired = this.authData.posData.department.flow_ordering_table;
								if (tableRequired) {
									this.showNewOrderModal = true;
									this.$nextTick(() => {
										this.$refs['new-order-modal'].openModal(null, user);
									})
								} else {
									this.createTempOrder(null, null, user)
								}

							} else {
								this.$refs['confirmation-modal-component'].show({
									title: 'Error',
									message: 'This person has posting_allowed parameter set to false',
									okButton: 'OK',
								})
							}
						} else {
							this.$refs['confirmation-modal-component'].show({
								title: 'Error',
								message: `No users or items found with this barcode (${data.code})`,
								okButton: 'OK',
							})
						}
					})
					.catch((err) => console.error(err))
				}
			}

		},
		createTempOrder(data, d1, userFromScanner) {
			let tempOrder = {
				payers: data?.payers ? [data.payers] : (userFromScanner ? [userFromScanner] : []),
				id: constants.tempOrderID, // just an indicator for temp order so that SelectedOrder.vue could differentiate
				active: true,
				items: [],
				opened_by: {
					name: `${this.authUser.user.first_name !== null ? this.authUser.user.first_name : ''} ${this.authUser.user.last_name}`
				},
				seat: data?.seat,
				status: 1,
				table: data?.table ? parseInt(data.table) : null,
				subtotal: 0,
				tempId: window.crypto.getRandomValues(new Uint8Array(16)).join('')
			};
			if (tempOrder.payers.length) {
				tempOrder['payment_type'] = 1;
			};
			this.updateOrdersList(tempOrder);
			let tempOrders = JSON.parse(localStorage.getItem('tempOrders'));
			if (tempOrders) {
				tempOrders.unshift(tempOrder);
				localStorage.setItem('tempOrders', JSON.stringify(tempOrders));
			} else {
				localStorage.setItem('tempOrders', JSON.stringify([tempOrder]))
			};

			this.usersModalRef = false;
		},
		onInputClear() {
			this.debounceSearch({
				target: {
					value: ''
				}
			})
		},
		debounceSearch(e) {
			this.searchOrder = null;
			clearTimeout(this.debounce);
			this.debounce = setTimeout((event) => {
				this.searchOrder = e.target.value;
				this.getOrders({resetList: true, resetSelected: false});
			}, 500)
		},
		ordersListScrollHandle(e) {
			if (e.target.scrollTop + e.target.clientHeight >= e.target.scrollHeight) {
				if (!this.searchOrder) {
					this.getOrders({resetList: false, resetSelected: false});
				}
			}
		},
		splittingOrder() {
			if (this.selectedOrder.items.length > 0) {
				this.splitOrderModalRef = true;
				this.$nextTick(() => {
					this.$refs['splitOrderModalRef'].openModal();
				})
			}
		},
		idCheck(i) {
			if (i.id !== constants.tempOrderID && (i.id === this.combineOrdersIn.id)) {
				return true
			} else if ((i.tempId && (i.tempId === this.combineOrdersIn.tempId))) {
				return true
			}
			return false
		},
		isHighlighted(i) {
			if (this.highlighted !== null) {
				if (this.highlighted.id !== constants.tempOrderID && (this.highlighted.id === i.id)) {
					return true
				} else if (this.highlighted.id === constants.tempOrderID && (this.highlighted.tempId === i.tempId)) {
					return true
				}
			} else {
				return false
			}
		},
		turnOffCombineOrder() {
			this.combineOrder = false;
		},
		onOrderSelect(i) {
			if (!this.orderLoading) {
				if (this.selectedOrder) {
					if (i.id === constants.tempOrderID) {
						if (this.selectedOrder.tempId === i.tempId) {
							// console.log('temp');
							return;
						}
					} else {
						if (this.selectedOrder.id === i.id) {
							// console.log('id', i.id);
							this.$emit('updateOrder', {...i, active: true});
							return;
						}
					}
				}
				this.orders.forEach((o) => {
					o['active'] = false;
					if (o.id === constants.tempOrderID) {
						if (o.tempId === i.tempId) {
							o['active'] = true;
						}
					} else {
						if (o.id === i.id) {
							o['active'] = true;
							if (!this.selectedOrder) {
								// this.$emit('updateOrder', o);
							}
						}
					}
				})
				this.$emit('updateOrder', {...i, active: true});
			}
		},
		openNewOrderModal() {

			if (!this.getBusinessDay || !this.getBusinessDay.active) {
				store.dispatch('alert/error', 'Business day is not in progress yet');
				return;
			};
			if (this.authData.status.loggedIn && this.authData.posId) {
                if(this.orderingMode){this.loadDiningSeatings();return;}
                // Dining's required-seat/guest flags do not change the basic POS flow.
                if(!this.authData.posData.department.retail_mode){
                    this.createTempOrder({table:'',seat:null});return;
                }
				let guestRequired = this.authData.posData.department.flow_ordering_guest;
				let tableRequired = this.authData.posData.department.flow_ordering_table;

				if (guestRequired && tableRequired) {
					this.showNewOrderModal = true;
					this.$nextTick(() => {
						this.$refs['new-order-modal'].openModal();
					})
				} else if (guestRequired && !tableRequired) {
					this.usersModalRef = true;
					this.$nextTick(() => {
						this.$refs['usersModalRef'].openModal({
							modalTitleText: 'Set the payer',
							modalSubmitBtnText: 'OK'
						});
					})
				} else if (!guestRequired && tableRequired) {
					this.showNewOrderModal = true;
					this.$nextTick(() => {
						this.$refs['new-order-modal'].openModal();
					})
				} else if (!guestRequired && !tableRequired) {
					/*this.emmiter.emit('addTempOrder', {
						table: '',
						seat: null
					});*/
					this.createTempOrder({
						table: '',
						seat: null
					})
				}
			}
		},
		setPayer(data) {
			this.createTempOrder({
				table: '',
				seat: null,
				payers: data
			})
		},
		configureOrderStatus(data) {
			let orderedStatus = data.items.filter((i) => {return i.status === 1});
			let placesStatus = data.items.filter((i) => {return i.status === 2});
			if (!data.items.length || orderedStatus.length) {
				return 'redTable'
			} else if (!orderedStatus.length && placesStatus.length) {
				return 'yellowTable'
			} else if (!orderedStatus.length && !placesStatus.length) {
				return 'greenTable'
			}
		},
		openOrderOptionsModal(order) {
			if (this.authUser.user.role === 'waiter assist') {
				return;
			};
			// console.log(order.table);
			// console.log(this.selectedOrder?.table);
			// this.highlighted = this.selectedOrder? this.selectedOrder : order;
			// this.combineOrdersIn = this.selectedOrder? this.selectedOrder : order;
			this.highlighted = order;
			this.combineOrdersIn = order;
			this.showOrderOptionsModal = true;
			this.orders.forEach((i) => {
				i['idCheck'] = this.idCheck(i);
			})
			this.$nextTick(() => {
				this.$refs['order-options-modal'].openModal(this.selectedOrder? this.selectedOrder : order);
			})
		},
		closeOrderOptionsModal() {
			this.showOrderOptionsModal = false;
		},
		combineOrders() {
			if (this.hasCheckedOptions) {
				let arr = this.orders.filter((o) => {return o.checked});
				if (this.combineOrdersIn.items.length < 1 || arr.some(a => a.items.length < 1)) {
					this.openHasAlcoholModal('The items field is required for all orders which combining');
					return
				}
				this.combineOrdersAPI({
					ordersToCombine: arr,
					ordersCombineDetails: this.combineOrdersIn
				})
			}
		},
		onCombineOrdersModalClose() {
			this.highlighted = null;
		},
		resetCombine() {
			this.combineOrder = false;
			this.orders.forEach((o) => {
				o['checked'] = false;
			})
		},
		handleAPIResponse(data, refreshList, closeModal, resetSelected) {
			if (closeModal) {
				this.emmiter.emit('closeModal');
			}
			if (data) {
				this.order = data;
				this.order.items = formatDataService.handleCondimentsModifiers(this.order.items);
				this.$emit('updateOrder', {...this.order, active: true})
			}
			if (refreshList) {
				this.getOrders({resetList: refreshList, resetSelected: resetSelected});
				/*this.emmiter.emit('refreshOrderList', {resetList: refreshList, resetSelected: resetSelected});*/
			}
		},
		openHasAlcoholModal(data) {
			this.$refs['confirmation-modal-component'].show({
				title: 'Attention',
				message: data,
				okButton: 'OK',
			})
		},
        async combineOrdersAPI(data) {
            if(this.loading)return;
            const selected=[data.ordersCombineDetails,...data.ordersToCombine];
            if(selected.some(o=>o.id===constants.tempOrderID)){
                store.dispatch('alert/error','Combine requires saved checks. Unsaved basic POS drafts cannot be combined with server checks.');return;
            }
            const payer=data.ordersCombineDetails.payers?.[0];
            if(selected.some(o=>o.items.some(item=>item.legal_age_class===1)) &&
                (!payer || payer.age<=this.legalAge.ADDITION_LEGAL_AGE_ALCOHOL || payer.intoxication_state)){
                this.openHasAlcoholModal('Items have age restrictions. Select an eligible payer for the target check before combining.');return;
            }
            this.loading=true;
            const target=data.ordersCombineDetails.id;
            const sources=data.ordersToCombine.map(o=>o.id).filter(id=>id!==target).sort();
            const key=`combine:${target}:${sources.join(',')}`;
            const command=sessionStorage.getItem(key) || crypto.randomUUID();
            sessionStorage.setItem(key,command);
            try {
                await axios.post(`/kitchen/orders/${target}/combine`,{command_id:command,source_ids:sources});
                sessionStorage.removeItem(key);
                this.loading=false;
                await this.getOrders({resetList:true,resetSelected:true},target);
                this.turnOffCombineOrder();
            } catch(e) {
                if(e.response && e.response.status<500)sessionStorage.removeItem(key);
                store.dispatch('alert/error',e.response?.data?.message || 'Combine was not confirmed. Reload and retry the same selection.');
            } finally {this.loading=false;}
        },
		splitOrders(data) {
			let deepCopy = JSON.parse(JSON.stringify(this.selectedOrder));
			data.selected.forEach((o) => {
				o.count = o.qty_to_split;
				if (data.newTable?.seat) {
					o.seat = data.newTable.seat
				};
			});
			deepCopy.items.forEach((o, index) => {
				data.selected.forEach(oo => {
					if (oo.id === o.id) {
						if (o.count - o.qty_to_split === 0) {
							o.to_delete = true;
						} else {
							o.count -= o.qty_to_split
						}
					}
				})
			});
			deepCopy.items = deepCopy.items.filter((o, index, a2) => {if (!o.to_delete) {return o} });
			let orderSplitTo = {
				table: !data.newTable ? (deepCopy.table ? deepCopy.table : null) : (data.newTable ? data.newTable.table : null),
				is_split: true,
				payers: data.newPayer ? [data.newPayer] : [],
				seat: !data.newTable ? (deepCopy.seat ? deepCopy.seat : null) : (data.newTable ? data.newTable.seat : null),
				items: data.selected,
				payment_type: 1
			};
			deepCopy.items = formatDataService.handleCondimentsModifiers(deepCopy.items);
			orderService.createNewOrder(orderSplitTo.id, formatDataService.formatItemsForAPI(orderSplitTo.items), orderSplitTo, deepCopy.id).then((res) => {
				if (res) {
					if (!deepCopy.items.length) {
						orderService.cancelOrder(deepCopy).then((res) => {
							if (res) {
								this.handleAPIResponse(null, true, true, true);
								/*this.handleAPIResponse(null, false, false, false);*/
								// this.createTempOrder(deepCopy.table, deepCopy.seat, deepCopy.payers[0])
							}
						})
						.catch((err) => console.error(err));
					} else {
						orderService.updateOrder(formatDataService.formatItemsForAPI(deepCopy.items), deepCopy).then((res) => {
							if (res) {
								this.handleAPIResponse(null, true, true, true);
								/*this.handleAPIResponse(res.data, false, false, false);*/
							}
						});
					};
				};
			})
			.catch((err) => console.error(err))
			.finally(() => {})
		},
	},
}
</script>

<style lang="less" scoped>
input[type="checkbox"] {
	display: none;
}

/* check icon styles */
label {
	color: #000;
	cursor: default;
	font-weight: normal;
}

/* checkbox styles */
label:before {
	content: " ";
	color: #000;
	display: inline-block;
	position: relative;
	text-align: center;
	text-indent: 0px;
	width: 24px;
	height: 24px;
	background: #FFF;
	border: 1px solid #e3e3e3;
	border-image: initial;
	vertical-align: middle;
}

input:checked + label:before {
	content: "\2714";
	background: #3F8EC5;
	color: white;
	border: 1px solid #3F8EC5;


}

input:disabled + label:before {
	background: #eee;
	color: #aaa;
}

#orders-list {
	.controls-wrapper {
		display: flex;
		flex-wrap: nowrap;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 10px;
		box-sizing: border-box;
		padding: 0 10px 0 5px;
		width: 100%;
		// height: 70px;
		.fn_btn {
			height: 60px;
			width: 174px;
			padding: 12px;

			span {
				font-style: normal;
				font-weight: 600;
				font-size: 16px;
				line-height: 21px;
			}
		}

		div {
			&:first-child {
				margin-right: 12px;
			}
		}

		// .btn-next {
		// 	box-sizing: border-box;
		// 	width: calc(100% - 72px);
		// }
	}
	:deep(#search-bar) {
		// margin-bottom: 10px;
		width: 100%;
		box-sizing: border-box;
		padding: 0 5px;
	}
	.list {
		width: 100%;
		height: calc(100% - 119px);
		// height: 100%;
		overflow-y: scroll;
		-ms-overflow-style: none; /* IE and Edge */
		scrollbar-width: none; /* Firefox */
		box-sizing: border-box;
		padding: 0 5px;

		&::-webkit-scrollbar {
			display: none;
		}

		.order {
			padding: 12px;
			min-height: 94px;
			background-color: #ffffff;
			margin-bottom: 10px;
			border-radius: 6px;
			box-shadow: 0 1px 4px 0 #a7a7a7;
			cursor: pointer;
			transition: all 200ms;
			box-sizing: border-box;
			width: 100%;
			position: relative;
			overflow: hidden;

			&.highlighted {
				// z-index: 999;
			}

			&.active-order {
				box-shadow: 0 1px 2px 1px #a7a7a7;
			}

			&:before {
				border-top-left-radius: 6px;
				border-bottom-left-radius: 6px;
				content: '';
				width: 4px;
				height: 100%;
				position: absolute;
				left: 0;
				top: 0;
				opacity: 0;
				transition: opacity 500ms;
			}

			.table {
				display: flex;
				align-items: center;
				justify-content: space-between;

				.table-wrapper {
					display: flex;
				}

				.checkbox-wrap {
					img {
						width: 18px;
						height: 18px;
					}
				}

				.order-options {
					height: 4px;
					padding: 5px;
				}

				&-number {
					margin-left: 12px;
					font-size: 14px;
					line-height: 24px;
					letter-spacing: -0.025em;
					color: #000000;
					font-weight: 600;
				}
			}

			.text {
				font-weight: 600;
				font-size: 10px;
				line-height: 18px;
				text-transform: uppercase;
				color: #1c282d;
				text-align: left;
				margin: 3px 0;

				span {
					font-weight: normal;
					font-size: 12px;
					line-height: 16px;
					color: #000000;
				}
			}
		}

		.active-order {
			&:before {
				opacity: 1;
			}
		}
	}
}
@media (max-width: 1200px) {
  #orders-list {
    .controls-wrapper {
      .def-btn {
        padding: 0;
      }

      img {
        display: none;
      }
    }
  }
}

@media (max-width: 850px) {
  #orders-list {}
}
</style>

<style scoped>
.dining-table-card{padding:10px;margin:8px 0;border:1px solid #ccdae5;background:white;border-radius:6px}.dining-table-card small{display:block;margin:5px 0}.dining-table-card button{padding:9px;margin:5px 0;width:100%;border:1px solid #b7d1e3;border-radius:4px;background:#edf6fc;text-align:left}
</style>

<style>
.ordering-overlay{position:fixed;inset:0;background:#0006;z-index:9500;display:flex;align-items:center;justify-content:center;padding:20px;font:14px Arial,sans-serif;color:#252b38}.ordering-dialog{background:white;border-radius:12px;box-shadow:0 12px 36px #0003;width:440px;max-width:100%;max-height:90vh;display:flex;flex-direction:column;text-align:left}.ordering-dialog header,.ordering-dialog footer{display:flex;align-items:center;justify-content:space-between;padding:18px;border-bottom:1px solid #edf0f4;gap:12px}.ordering-dialog footer{border-top:1px solid #edf0f4;border-bottom:0}.ordering-dialog header strong{font-size:18px}.ordering-dialog header button{border:0;font-size:24px}.ordering-dialog button{background:white;border:1px solid #dce2eb;border-radius:7px;padding:10px 14px;color:inherit;cursor:pointer}.ordering-dialog button.primary{background:#4293c6;color:white;border-color:#4293c6}.ordering-dialog button:disabled{opacity:.45;cursor:default}.ordering-dialog .dialog-body{padding:18px;overflow:auto;min-height:0}.ordering-dialog input{width:100%;box-sizing:border-box;border:1px solid #dce2eb;border-radius:8px;padding:12px;background:#f8f9fb}.station-picker{display:flex;justify-content:space-between;align-items:center;font-size:12px;color:#667085;padding:12px 0}.station-picker select{padding:6px;border:1px solid #dce2eb;border-radius:6px}.table-options{max-height:45vh;overflow:auto}.table-options>button{width:100%;display:flex;align-items:center;justify-content:space-between;padding:16px 12px;border:0;border-bottom:1px solid #edf0f4;border-radius:0}.table-options small{display:block;color:#758091;padding-top:5px}.ordering-dialog button.chosen{background:#edf5fb;border:1px solid #4293c6}
</style>

<style>.table-options button>span:first-child{text-align:left}#pos-root.ordering-mode #orders-list .controls-wrapper .fn_btn{min-width:0}#pos-root.ordering-mode #orders-list .controls-wrapper .fn_btn .text{font-size:12px!important;white-space:nowrap!important}</style>

<style>
#pos-root.ordering-mode #orders-list .list>.order{box-sizing:border-box;min-height:94px;padding:8px 10px;margin-bottom:7px}#pos-root.ordering-mode #orders-list .list>.order>.table{margin-bottom:4px}#pos-root.ordering-mode #orders-list .list>.order>.text{font-size:9px;line-height:15px;margin:0}#pos-root.ordering-mode #orders-list .list>.order>.text span{font-size:11px;line-height:15px}#pos-root.ordering-mode #orders-list .list>.order .table-number{font-size:14px}
</style>

<style>
#pos-root.ordering-mode #orders-list .list>.order{transition:none}
#pos-root.ordering-mode #orders-list .controls-wrapper .fn_btn span{font-size:12px!important;white-space:nowrap;line-height:16px}
</style>

<style>
@media(min-width:950px) and (max-width:1100px){#pos-root.ordering-mode #orders-list .controls-wrapper .refresh-btn{width:42px!important;min-width:42px!important}#pos-root.ordering-mode #orders-list .controls-wrapper .fn_btn{margin-right:8px!important;flex:1;padding:4px!important}#pos-root.ordering-mode #orders-list .controls-wrapper .fn_btn img{display:none!important}}
</style>

<style>
.ordering-dialog .table-options>button{padding:10px 8px;gap:12px;min-height:54px}
.ordering-dialog .table-description{flex:1;min-width:0}
.ordering-dialog .table-heading{display:flex;align-items:center;gap:10px;flex-wrap:wrap}
.ordering-dialog .table-status{display:inline-flex;align-items:center;justify-content:center;min-width:80px;min-height:26px;box-sizing:border-box;font-size:11px;line-height:16px;font-weight:500}
.ordering-dialog .table-capacity{flex:none;font-size:12px;color:#667085}
.ordering-dialog .table-options small{padding-top:3px;font-size:11px;line-height:16px}
.ordering-dialog input[aria-label="Enter table number"]{height:40px;margin-bottom:8px;padding:8px 12px;font:inherit;box-shadow:none;outline-offset:2px}
</style>
